var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assessment-input"},[_c('p',[_vm._v("请选择，最多 "+_vm._s(_vm.maxSelections)+" 项")]),_c('OptionList',{attrs:{"value":_vm.value,"options":_vm.options,"multiple":"","disabled":_vm.disabled,"disabled-options":_vm.disabledOptions},on:{"input":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }